import { Table, Button, Tag, message } from "antd";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import {
  addOutletSecret,
  getMerchantOutlets,
} from "../../actions/merchant_actions";

export default function MerchantOutlets({ merchantData }) {
  const qc = useQueryClient();
  const businessUrn = useSelector((state) => state.account.businessUrn);

  const { data = [], isLoading } = useQuery({
    queryKey: ["merchant-outlets", businessUrn],
    queryFn: () => getMerchantOutlets(businessUrn),
  });

  const addMutation = useMutation({
    mutationFn: ({ businessUrn, payload }) =>
      addOutletSecret(businessUrn, payload),
    onSuccess: () => {
      message.success("Secret generated successfully");
      qc.invalidateQueries(["merchant-outlets", businessUrn]);
    },
  });

  const columns = [
    {
      title: "Outlet",
      dataIndex: "name",
    },
    {
      title: "Address",
      render: (_, r) =>
        `${r.address?.street_name || ""} ${r.address?.house_number || ""}, ${
          r.address?.town || ""
        }`,
    },
    {
      title: "Secrets",
      render: (_, r) =>
        r.secrets?.flatMap((m) => m.secrets.map((s) => <Tag key={s}>{s}</Tag>)),
    },
    {
      title: "Action",
      render: (_, r) => (
        <Button
          type="primary"
          loading={addMutation.isLoading}
          onClick={() =>
            addMutation.mutate({
              businessUrn,
              payload: {
                merchant_urn: merchantData.urn,
                outlet_urn: r.urn,
              },
            })
          }
        >
          Generate Secret
        </Button>
      ),
    },
  ];

  return (
    <div className="outlet-secret-wrapper">
      <Table
        loading={isLoading}
        columns={columns}
        dataSource={data}
        rowKey="urn"
        pagination={false}
      />
    </div>
  );
}
